import React, {PureComponent} from 'react';
import './form.scss';
import pubsub from 'common/js/pubsub';
import logger from 'common/js/logger';
import loginUtil from 'common/js/login';

export default class Form extends PureComponent {
	constructor(props) {
		super(props)
		this.state = {
			isLogin: false,
			tipsMsg: ''
		};

		// 记录触发错误的输入框
		this.errorInput = null;

		this.showTips = this.showTips.bind(this);
		this.hideTips = this.hideTips.bind(this);
		this.inputPhone = this.inputPhone.bind(this);
		this.verifyPhone = this.verifyPhone.bind(this);
		this.inputEvt = this.inputEvt.bind(this);
		this.loginSubmit = this.loginSubmit.bind(this);
		this.showReg = this.showReg.bind(this);
		this.inputKeyUp = this.inputKeyUp.bind(this);
	}

	componentDidMount() {
		let self = this;

		this._mounted = true;
		this.refs.findPassword.setAttribute('href', 'https://aq.yy.com/p/pwd/fgt/mnew/index.do?appid=1&action=2&busiurl=' + encodeURIComponent(window.location.href));
	}

	componentWillUnmount() {
		this._mounted = false;
	}

	showTips(msg) {
		this._mounted && this.setState({
			tipsMsg: msg
		});
	}

	hideTips() {
		this._mounted && this.setState({
			tipsMsg: ''
		});
	}

	inputPhone(e) {
		let cInput = e.currentTarget,
			value = cInput.value;

		cInput.value = value.replace(/[^\d]/, '');

		this.inputEvt(e);
	}

	inputEvt(e) {
		let cInput = e.currentTarget;

		if(!this.errorInput || this.errorInput === cInput){
			this.errorInput = null;
			this.hideTips();
		}
	}

	inputKeyUp(e) {
		if(e && (e.keyCode === 13 || e.key === 'Enter')) {
			this.loginSubmit();
		}
	}

	verifyPhone(e) {
		let cInput = e.currentTarget,
			value = cInput.value;

		if( value && !( /^1[34578]\d{9}$/.test(value) ) ) {
			this.showTips("手机号码输入有误");
			this.errorInput = cInput;
		}
	}

	loginSubmit() {
		let self = this,
			account = this.refs.loginPhone.value,
			password = this.refs.loginPassword.value;

		if(!/^1[34578]\d{9}$/.test(account)) {
			this.errorInput = this.refs.loginPhone;
			this.showTips("请输入正确的手机号码");
			return false;
		}

		if(!password) {
			this.errorInput = this.refs.loginPassword;
			this.showTips("请输入密码");
			return false;
		}

		this._mounted && this.setState({
			isLogin: true
		});

		loginUtil.accountLogin({
			userName: account,
			password: password,
			success: function(res) {
				loginUtil.refreshUserInfo();
				pubsub.publish("showSuccessTips", {
					msg: '登录成功'
				});
			},
			fail: function(res) {
				self._mounted && self.setState({
					isLogin: false
				});
				self.showTips(res.description || "登录失败，请重试");
			}
		})

	}

	showReg() {
		pubsub.publish('showRegTab');
	}

	render() {
		return (
			<div className="m-form">
				{this.state.tipsMsg ? <p className="m-form_tips">{this.state.tipsMsg}</p> : ''}
				<div className="m-form_ipts">
					<div className="item item-acc">
						<input ref="loginPhone" type="tel" placeholder="请输入手机号码" maxLength="11" onInput={this.inputPhone} onBlur={this.verifyPhone} onKeyUp={this.inputKeyUp}/>
					</div>
					<div className="item item-pwd">
						<input ref="loginPassword" type="password" placeholder="请输入密码" maxLength="20" onInput={this.inputEvt} onKeyUp={this.inputKeyUp}/>
					</div>
				</div>

				<div className="m-form_rela">
					<a className="J-add_redirect" href="javascript:void(0)" title="手机号注册" onClick={this.showReg}>手机号注册</a>
					<a ref="findPassword" className="J-add_redirect" href="#" title="忘记密码">忘记密码</a>
				</div>

				<div className="m-form_submit">
					<a id="J-login_submit" type="button" className="submit" href="javascript:void(0)" onClick={this.loginSubmit}>{this.state.isLogin ? "登录中..." : "登录"}</a>
				</div>

			</div>
		);
	}
}




// WEBPACK FOOTER //
// ./src/views/login/form/LoginForm.jsx